import * as React from 'react';
import type { SVGProps } from 'react';
const SvgReaction = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm3.66 6.407a1.283 1.283 0 1 1 .003 2.566 1.283 1.283 0 0 1-.002-2.566Zm-7.32 0a1.283 1.283 0 1 1 .002 2.565 1.283 1.283 0 0 1-.003-2.565Zm9.292 6.143c-.42 2.396-2.782 4.058-5.632 4.058-2.85 0-5.21-1.662-5.63-4.058a.484.484 0 0 1-.008-.074c0-.346.42-.57.79-.443 1.42.49 3.078.74 4.85.74 1.77 0 3.428-.25 4.85-.74.366-.132.789.096.789.443a.48.48 0 0 1-.01.074Z"
    />
  </svg>
);
export default SvgReaction;
